module.exports = __webpack_public_path__ + "img/Forschung.04598350.webp";